import {
  mdiDelete,
  mdiDragHorizontalVariant,
  mdiCookie,
  mdiCalendarBlankOutline,
  mdiChevronDown,
  mdiDotsVertical,
  mdiMicrophone,
  mdiCamera,
  mdiMenuDown
} from '@mdi/js'

export default {
  'freshvue-delete': mdiDelete,
  'freshvue-drag': mdiDragHorizontalVariant,
  'freshvue-cookie': mdiCookie,
  'freshvue-calendar': mdiCalendarBlankOutline,
  'freshvue-dropdown': mdiChevronDown,
  'freshvue-options': mdiDotsVertical,
  'freshvue-audio-input': mdiMicrophone,
  'freshvue-video-input': mdiCamera,
  'freshvue-administration-menu-mobile': mdiDotsVertical,
  'freshvue-administration-menu-desktop': mdiMenuDown
}
